<mg-table [collectionComponent]="this" matSort stickyHeaders>

    <ng-container matColumnDef="mfaEnabled">
        <th id="mfaEnabled" mat-header-cell *matHeaderCellDef mat-sort-header>2FA</th>
        <td mat-cell *matCellDef="let row">
            <mat-icon *ngIf="row.mfaEnabled" title="2FA geactiveerd">screen_lock_portrait</mat-icon>
            <mat-icon *ngIf="!row.mfaEnabled && !row.isMfaExempt" title="2FA niet geregistreerd">mobile_off</mat-icon>
            <mat-icon *ngIf="row.isMfaExempt" title="Vrijgesteld van 2FA">password</mat-icon>
        </td>
    </ng-container>
    
    <ng-container matColumnDef="firstName">
        <th id="firstName" mat-header-cell *matHeaderCellDef mat-sort-header> Voornaam </th>
        <td mat-cell *matCellDef="let row"> {{row.firstName}} </td>
    </ng-container>

    <ng-container matColumnDef="lastName">
        <th id="lastName" mat-header-cell *matHeaderCellDef mat-sort-header> Achternaam </th>
        <td mat-cell *matCellDef="let row"> {{row.lastName}} </td>
    </ng-container>

    <ng-container matColumnDef="email">
        <th id="email" mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
        <td mat-cell *matCellDef="let row"> {{row.email}} </td>
    </ng-container>

    <ng-container matColumnDef="lastPasswordChanged">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Wachtwoord gewijzigd </th>
        <td mat-cell *matCellDef="let row"> {{row.lastPasswordChanged | date:'medium'}} </td>
    </ng-container>
    
    <ng-container matColumnDef="locked">
        <th id="locked" mat-header-cell *matHeaderCellDef mat-sort-header>Geblokkeerd</th>
        <td mat-cell *matCellDef="let row">
            <center><mat-icon *ngIf="row.locked">lock_person</mat-icon></center>
        </td>
    </ng-container>

    <ng-container matColumnDef="lastLogin">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Laatste Login </th>
        <td mat-cell *matCellDef="let row"> {{row.lastLogin | date:'medium'}} </td>
    </ng-container>



 </mg-table>